import { DateTime } from 'luxon';

import { FeedMessage, FeedMessageDto } from 'theSource/types';
import { MESSAGE_CREATION_DATE_FORMAT } from './constants';

export const mapFeedMessages = (messages?: FeedMessageDto[]) => {
  if (!messages || messages.length === 0) {
    return [];
  }

  return messages.map<FeedMessage>(mapFeedMessage);
};

export const mapFeedMessage = (message: FeedMessageDto) => ({
  id: message.id,
  body: message.body ?? '',
  createdAt: convertCreationDateToDateTime(message.created_at),
  imageUrl: message.image_url ?? '',
  link: message.link,
  linkLabel: message.link_label,
  title: message.title,
  read: message.read,
});

export const convertCreationDateToDateTime = (date: string) =>
  DateTime.fromFormat(date, MESSAGE_CREATION_DATE_FORMAT);
